/**
 * @generated SignedSource<<1de2af24e51c262cc6c291727ed5c828>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SinglePeriodMetric = "ENGAGEMENT" | "PRODUCT_DATE_TRACKER_REGISTERED" | "PRODUCT_DATE_TRACKER_TASKS_COMPLETED" | "TASK_EXECUTIONS_COMPLETED" | "TODO_CREATED" | "TODO_ISSUE_CREATED" | "TODO_ISSUE_RESOLVED" | "TODO_ISSUE_RESOLVED_AVG_TIME" | "TODO_RESOLVED" | "TODO_RESOLVED_AVG_TIME";
import { FragmentRefs } from "relay-runtime";
export type SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension$data = {
  readonly color: string | null;
  readonly id: string;
  readonly label: string;
  readonly metrics: ReadonlyArray<{
    readonly avg: number | null;
    readonly metric: SinglePeriodMetric;
    readonly total: number | null;
  }>;
  readonly " $fragmentType": "SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension";
};
export type SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension$key = {
  readonly " $data"?: SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension$data;
  readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SinglePeriodAnalyticsDimensionMetric",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metric",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SinglePeriodAnalyticsDimension",
  "abstractKey": null
};

(node as any).hash = "8fdc8db164c344bf101209ad6777c4fb";

export default node;
